import { render, staticRenderFns } from "./DiaryTable.vue?vue&type=template&id=5c852b95&scoped=true"
import script from "./DiaryTable.vue?vue&type=script&lang=js"
export * from "./DiaryTable.vue?vue&type=script&lang=js"
import style0 from "./DiaryTable.vue?vue&type=style&index=0&id=5c852b95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c852b95",
  null
  
)

export default component.exports